import mastercardLogo from '../images/logo-mastercard.svg';
import visaLogo from '../images/logo-visa.svg';
import amexLogo from '../images/logo-amex.svg';

export const cardLogos = {
  MASTERCARD: mastercardLogo,
  VISA: visaLogo,
  AMEX: amexLogo,
};
